<template>
  <div class="margin-page">
    <Loading :center="false" v-show="loading" />
    <div v-show="!loading">
      <b-row>
        <b-col xs="12" sm="12" md="12" lg="12" xl="12">
          <RadioGroup :formName="formName" :options="[
            { text: 'Pagar', value: 1 },
            { text: 'Receber', value: 2 },
          ]" v-model="payableReceivableCreateUpdate.type" />
        </b-col>
      </b-row>
      <Molded>
        <b-row>
          <b-col xs="12" sm="12" md="6" lg="6" xl="4">
            <InputText title="Descrição" field="description" :formName="formName" :required="true" :maxLength="200"
              v-model="payableReceivableCreateUpdate.description" />
          </b-col>
          <b-col xs="12" sm="12" md="6" lg="6" xl="2">
            <InputText title="Documento" field="document" :formName="formName" :maxLength="50"
              v-model="payableReceivableCreateUpdate.document" />
          </b-col>
          <b-col xs="12" sm="12" md="6" lg="6" xl="2">
            <InputDecimal title="Valor" field="value" :formName="formName" :required="true" :allowNegative="false"
              v-model="payableReceivableCreateUpdate.value" />
          </b-col>
          <b-col xs="12" sm="12" md="6" lg="6" xl="2">
            <DateTime title="Vencimento" field="dueDate" format="DD/MM/YYYY" type="date" placeholder
              :formName="formName" :required="true" v-model="payableReceivableCreateUpdate.dueDate" />
          </b-col>
          <b-col xs="12" sm="12" md="6" lg="6" xl="2">
            <DateTime title="Competência" field="competenceDate" format="DD/MM/YYYY" type="date" placeholder
              :formName="formName" :required="true" v-model="payableReceivableCreateUpdate.competenceDate" />
          </b-col>
        </b-row>
      </Molded>
      <div class="repeater">
        <b-row>
          <b-col xs="12" sm="12" md="12" lg="6" xl="6" v-if="!id">
            <Toggle title="Repetir lançamento" :color="'var(--color-brand)'" v-model="isRepeater" />
          </b-col>
        </b-row>
      </div>
      <Molded v-if="isRepeater">
        <b-row>
          <b-col xs="12" sm="12" md="12" lg="3" xl="3">
            <SelectStatic title="Intervalo" fieldTarget="timeZone" :data="[
              { content: 'Diariamente', id: 'daily' },
              { content: 'Quinzenal', id: 'quaweekly' },
              { content: 'Mensalmente', id: 'monthly' },
              { content: 'Anualmente', id: 'annually' },
            ]" :markFormDirty="true" v-model="payableReceivableCreateUpdate.repeater" />
          </b-col>
          <b-col xs="12" sm="12" md="12" lg="2" xl="2">
            <InputNumber title="Vezes" field="number" :formName="formName" :required="false" :maxLength="2" type="int"
              v-model="payableReceivableCreateUpdate.recurrence" />
          </b-col>
        </b-row>
      </Molded>
      <br v-if="isRepeater" />
      <div
        v-if="payableReceivableCreateUpdate.numberRentPayment > 0 || payableReceivableCreateUpdate.numberRentTeam > 0">
        <Alert type="info">
          <span>
            Conta vinculada a Locação
            <b v-if="payableReceivableCreateUpdate.numberRentTeam > 0">Nº {{
              payableReceivableCreateUpdate.numberRentTeam }}</b>
            <b v-else-if="payableReceivableCreateUpdate.numberRentPayment > 0">Nº {{
              payableReceivableCreateUpdate.numberRentPayment }}</b>
            , sua alteração resultará em uma modificação na <b>Locação</b>.
          </span>
        </Alert>
      </div>
      <b-tabs v-model="tabIndex">
        <b-tab title="Dados">
          <b-row>
            <b-col xs="12" sm="12" md="12" lg="12" xl="12">
              <Select title="Destinatário (Nome ou CNPJ/CPF)" field="recipient" :formName="formName" :required="true"
                url="api/v1/finance/payable-receivable/select-all-recipient"
                v-model="payableReceivableCreateUpdate.recipient" nameNewRegister="customerSupplierOrCollaboratorCreate"
                titleNewRegister="Destinatário" :widthNewRegister="1200" :heightNewRegister="250">
                <RadioGroup :formName="formName" title="O que será cadastrado?" :options="[
                  { text: 'Cliente ou Fornecedor', value: 1 },
                  { text: 'Colaborador', value: 2 },
                ]" v-model="typeRecipient" />
                <CustomerSupplierCreate v-if="typeRecipient == 1" formName="customerSupplierCreate"
                  :_hideSideBar="false" v-model="payableReceivableCreateUpdate.recipient" />
                <CollaboratorCreate v-else v-model="payableReceivableCreateUpdate.recipient" />
              </Select>
            </b-col>
          </b-row>
          <b-row>
            <b-col xs="12" sm="12" md="12" lg="6" xl="6">
              <Select title="Categoria" field="category" :formName="formName" :required="false"
                url="api/v1/finance/chart-of-accounts/select-all" :propsParams="{ any: typeCostCenter }"
                v-model="payableReceivableCreateUpdate.chartOfAccounts" :showNewRegister="false">
              </Select>
            </b-col>
            <b-col xs="12" sm="12" md="12" lg="6" xl="6">
              <Select title="Tipo de Pagamento" field="typePayment" :formName="formName" :required="false"
                v-model="payableReceivableCreateUpdate.typePayment" url="/api/v1/finance/type-payment/select-all"
                nameNewRegister="typePaymentCreateUpdate" titleNewRegister="Tipo de Pagamento" :widthNewRegister="500"
                :heightNewRegister="250">
                <TypePaymentCreateUpdate :registerInSelect="true" v-model="payableReceivableCreateUpdate.typePayment" />
              </Select>
            </b-col>
          </b-row>
          <b-row>
            <b-col xs="12" sm="12" md="12" lg="12" xl="12">
              <Select title="Conta Bancária" field="bankAccount" :formName="formName" :required="false"
                :disabled="hasBillet" v-model="payableReceivableCreateUpdate.bankAccount"
                url="api/v1/finance/bank-account/select-all" :showNewRegister="false">
              </Select>
              <Alert type="info" v-if="hasBillet">
                <span> Não é permitido alterar a Conta Bancária, pois existe <b>Boleto Bancário</b> vinculado! </span>
              </Alert>
            </b-col>
          </b-row>
          <CheckboxSimple :title="'Marcar como ' + title" v-model="payableReceivableCreateUpdate.paid" />
          <div v-if="payableReceivableCreateUpdate.paid">
            <b-row>
              <b-col xs="12" sm="12" md="6" lg="6" xl="2">
                <DateTime title="Data" field="conciliationDate" format="DD/MM/YYYY" type="date" placeholder
                  :formName="formName" :required="false" v-model="payableReceivableCreateUpdate.conciliationDate" />
              </b-col>
              <b-col xs="12" sm="12" md="6" lg="6" xl="2">
                <InputDecimal title="Desconto" field="discount" :formName="formName" :required="false"
                  :allowNegative="false" v-model="payableReceivableCreateUpdate.discount" />
              </b-col>
              <b-col xs="12" sm="12" md="6" lg="6" xl="2">
                <InputDecimal title="Multa" field="fees" :formName="formName" :required="false" :allowNegative="false"
                  v-model="payableReceivableCreateUpdate.fees" />
              </b-col>
            </b-row>
          </div>
        </b-tab>
        <b-tab title="Histórico de Baixas" v-if="payableReceivableCreateUpdate.id && hasPartialPaymentHistory">
          <PayableReceivablePartialPaymentHistory v-if="tabIndex === historyTabIndex"
            :payableReceivableId="payableReceivableCreateUpdate.id" :collapsible="false" />
        </b-tab>
        <b-tab title="Observações">
          <EditorHtml field="observation" :required="false" :maxLength="1500"
            v-model="payableReceivableCreateUpdate.observation" />
        </b-tab>
        <b-tab title="Locação Vinculada"
          v-if="payableReceivableCreateUpdate.id && payableReceivableCreateUpdate.type == 1">
          <RelationshipRentCreateUpdate :payableReceivableId="payableReceivableCreateUpdate.id"
            :payableReceivableValue="payableReceivableCreateUpdate.value" />
        </b-tab>
        <b-tab title="Anexo" v-if="payableReceivableCreateUpdate.id">
          <FileManager :showInModal="false" source="finance" :genericId="payableReceivableCreateUpdate.id" />
        </b-tab>

        <b-tab title="Auditoria"
          v-if="payableReceivableCreateUpdate.id && (userLogged.user.userName === 'UserTemp' || hasRule('Audit'))">
          <TimelineLog v-if="tabIndex === auditTabIndex" :id="payableReceivableCreateUpdate.id" />
        </b-tab>
      </b-tabs>
      <SaveCancel :formName="formName" :marginBottom="15" :showFixed="cloneMode" :forceEnableSave="cloneMode">
        <Button _key="saveAndClose" eventName="saveAndClose" classIcon="fa-solid fa-floppy-disk-circle-arrow-right"
          title="Salvar e Fechar" type="info" :disabled="cloneMode ? false : !isFormValid(formName)" size="medium" />
      </SaveCancel>
    </div>
  </div>
</template>

<script>


import Molded from "@/ui/layout/Molded.vue";
import CheckboxSimple from "@/ui/forms/CheckboxSimple.vue";
import RadioGroup from "@/ui/forms/RadioGroup.vue";
import Select from "@/ui/forms/Select";
import SelectStatic from "@/ui/forms/SelectStatic";
import InputText from "@/ui/forms/InputText";
import InputNumber from "@/ui/forms/InputNumber";
import InputDecimal from "@/ui/forms/InputDecimal";
import Button from "@/ui/forms/Button";
import DateTime from "@/ui/forms/DateTime";
import Toggle from "@/ui/forms/Toggle";
import Loading from "@/ui/shared/Loading.vue";
import SaveCancel from "@/ui/shared/SaveCancel";
import Alert from "@/ui/layout/Alert";
import EditorHtml from "@/ui/forms/EditorHtml";
import FileManager from "@/ui/shared/file-manager/FileManager";
import TimelineLog from '@/components/modules/adm/audit-log/TimelineLog.vue';

import CustomerSupplierCreate from '@/components/modules/shared/customer-supplier/CustomerSupplierCreate.vue';
import CollaboratorCreate from '@/modules/human-resources/components/CollaboratorCreate.vue';
import TypePaymentCreateUpdate from '@/modules/finance/components/typePayment/TypePaymentCreateUpdate.vue';

import RelationshipRentCreateUpdate from '@/components/modules/finance/relationship-rent/RelationshipRentCreateUpdate.vue';
import PayableReceivablePartialPaymentHistory from "./PayableReceivablePartialPaymentHistory.vue";
import PayableReceivableCreateUpdate from "../../models/PayableReceivable";
import PayableReceivableService from "../../services/payableReceivable.service.js";
import { getPayableReceivableTypeCostCenter } from "../../services/payableReceivableList.config.js";

import { mapGetters, mapActions, mapMutations, mapState } from "vuex";

export default {
  name: "PayableReceivableCreateUpdate",
  props: {
    id: String,
    cloneMode: {
      type: Boolean,
      default: false,
    },
    value: Object,
    reloadList: Function,
  },
  components: {
    InputText,
    InputDecimal,
    InputNumber,
    Select,
    SelectStatic,
    RadioGroup,
    CheckboxSimple,
    Molded,
    Button,
    Alert,
    EditorHtml,
    DateTime,
    Toggle,
    TypePaymentCreateUpdate,
    Loading,
    SaveCancel,
    CustomerSupplierCreate,
    CollaboratorCreate,
    FileManager, RelationshipRentCreateUpdate, TimelineLog, PayableReceivablePartialPaymentHistory
  },
  data() {
    return {
      formName: "payableReceivableCreateUpdateForm",
      payableReceivableCreateUpdate: new PayableReceivableCreateUpdate(),
      urlCreate: "/api/v1/finance/payable-receivable/create",
      urlUpdate: "/api/v1/finance/payable-receivable/update",
      urlGetById: "/api/v1/finance/payable-receivable/get-by-id",
      isRepeater: false,
      loading: false,
      typeRecipient: 1,
      tabIndex: 0,
      hasPartialPaymentHistory: false,
    };
  },
  created() {
    this.loadData();
  },
  computed: {
    ...mapState("user", ["userLogged"]),
    ...mapGetters("validation", ["isFormValid"]),
    ...mapGetters("generic", ["event", "isLoading"]),
    ...mapGetters("user", ["hasRule"]),
    typeCostCenter() {
      return getPayableReceivableTypeCostCenter(this.payableReceivableCreateUpdate.type);
    },
    historyTabIndex() {
      return 1;
    },
    auditTabIndex() {
      let index = 1;
      if (this.hasPartialPaymentHistory) index += 1;
      index += 1;
      if (this.payableReceivableCreateUpdate.type == 1) index += 1;
      index += 1;
      return index;
    },
    title() {
      if (this.payableReceivableCreateUpdate.type == 1) return "Pago ";
      return "Recebido ";
    },
    hasBillet() {
      if (this.payableReceivableCreateUpdate.tokenBillet) return true;
      return false;
    }
  },
  methods: {
    ...mapActions("generic", ["postApi", "putApi", "getApi"]),
    ...mapMutations("generic", ["removeLoading", "hideSideBar"]),
    ...mapMutations("validation", ["removeFormDirty"]),
    loadData() {
      if (this.id) {
        this.getById();
        return;
      }

      this.payableReceivableCreateUpdate = new PayableReceivableCreateUpdate();
      this.isRepeater = false;
      this.typeRecipient = 1;
      this.tabIndex = 0;
      this.hasPartialPaymentHistory = false;
      this.removeFormDirty();
    },
    async checkPartialPaymentHistory() {
      const response = await PayableReceivableService.getAllPartialPayment(this.id);
      this.hasPartialPaymentHistory = !!(response.success && response.content.items?.length);
    },
    applyCloneMode() {
      this.payableReceivableCreateUpdate.id = "";
      this.payableReceivableCreateUpdate.paid = false;
      this.payableReceivableCreateUpdate.conciliationDate = "";
      this.payableReceivableCreateUpdate.discount = 0;
      this.payableReceivableCreateUpdate.fees = 0;
      this.payableReceivableCreateUpdate.tokenBillet = "";
    },
    closeCreateUpdateSideBar() {
      this.hideSideBar();
      this.$root.$emit("bv::toggle::collapse", "my-sidebar");
    },
    create(eventName) {
      let params = {
        url: this.urlCreate,
        obj: this.payableReceivableCreateUpdate,
      };
      this.postApi(params).then((response) => {
        if (response.success && eventName == "saveAndClose") {
          if (this.reloadList) this.reloadList();
          this.closeCreateUpdateSideBar();
        }
        if (response.success) {
          this.payableReceivableCreateUpdate.id = response.content.id;
        }
        this.removeLoading(["saveSaveCancel", "saveAndClose"]);
      });
    },
    update(eventName) {
      let params = {
        url: this.urlUpdate,
        obj: this.payableReceivableCreateUpdate,
      };
      this.putApi(params).then((response) => {
        if (response.success && eventName == "saveAndClose") {
          if (this.reloadList) this.reloadList();
          this.closeCreateUpdateSideBar();
        }
        this.removeLoading(["saveSaveCancel", "saveAndClose"]);
      });
    },
    getById() {
      this.loading = true;
      this.checkPartialPaymentHistory();
      let params = { url: this.urlGetById, obj: { id: this.id } };
      this.getApi(params).then((response) => {
        this.payableReceivableCreateUpdate.update(response.content);
        if (this.cloneMode) {
          this.applyCloneMode();
        }
        this.loading = false;
        this.removeFormDirty();
      });
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "cancelSaveCancel") {
          this.closeCreateUpdateSideBar();
        }
        if (event.name == "saveSaveCancel" || event.name == "saveAndClose") {
          if (!this.payableReceivableCreateUpdate.id) this.create(event.name);
          if (this.payableReceivableCreateUpdate.id) this.update(event.name);
        }
      },
      deep: true,
    },
    id() {
      this.loadData();
    },
    cloneMode() {
      this.loadData();
    },
    isRepeater: {
      handler(isRepeater) {
        if (!isRepeater) this.payableReceivableCreateUpdate.repeater = { id: "", content: "" };
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.margin-page {
  margin-right: 10px;
  margin-bottom: 90px;
}

.repeater {
  margin-top: 15px;
  margin-bottom: 15px;
}

.div-balance {
  font-size: 16px;
  margin-top: 3px;
}

.positive {
  color: var(--color-brand);
}

.negative {
  color: var(--color-danger);
}
</style>
